import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import CommonTexField from "components/common-component/textField";
import { AI_getUserData, AI_send_feedback } from "APIs/user";
import { useInstance, useAIEventHandler } from "easy-redux-http-call";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import FeedBackConfirmationModal from "./FeedBackConfirmationModal";
import CommonButton from "components/common-component/Button";

const useStyle = makeStyles((theme) => ({
  hrClosebtn: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
}));

const FeedBack = ({
  open = false,
  handleCloseAction = () => {},
  setOpenConfirmationModal,
}) => {
  const classes = useStyle();
  const [sendAnonymous, setSendAnonymous] = useState(false);

  const getUserData = useInstance(AI_getUserData);
  const feedBackData = useInstance(AI_send_feedback);

  const handleSendFeedBack = () => {
    let payload = { ...values };
    if (!sendAnonymous) {
      payload.employee_id = getUserData?.data?.user?.employee_id;
    }
    AI_send_feedback.call({
      params: payload,
    });
  };

  const feedBackValidationSchema = yup.object().shape({
    general_feedback: yup.string().required("General feed is required"),
  });

  const { handleSubmit, handleChange, values, errors, touched, handleBlur } =
    useFormik({
      initialValues: {
        general_feedback: "",
        wild_zone_idea: "",
        improvements_osis: "",
        shoutout: "",
      },
      validationSchema: feedBackValidationSchema,
      onSubmit: handleSendFeedBack,
    });

  useAIEventHandler(AI_send_feedback, {
    onSuccess: (data) => {
      handleCloseAction();
      setOpenConfirmationModal(true);
    },
    onError: (error) => {},
  });

  return (
    <>
      <Dialog open={open}>
        <form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogTitle>
            <Typography variant="h4">
              Embark on a journey with us! Your insights are the compass guiding
              us to new horizons. Together, let's sculpt a workplace that's not
              just a job, but an adventure.
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => handleCloseAction()}
              className={classes.hrClosebtn}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <CommonTexField
              placeholder=" Your thoughts are the secret sauce of our success. Pour them out here – the more, the merrier! What's working? What's not? Unleash your wisdom!"
              multiline
              rows={5}
              name="general_feedback"
              label="General Feedback"
              value={values?.general_feedback}
              onChange={handleChange}
              error={
                touched?.general_feedback &&
                errors?.general_feedback !== undefined
                  ? true
                  : false
              }
              helperText={touched?.general_feedback && errors?.general_feedback}
              onBlur={handleBlur}
            />
            <CommonTexField
              placeholder="Got a brainwave that feels like it belongs in a sci-fi movie? We want it! This is the playground for your craziest, most groundbreaking ideas. No idea is too outlandish!"
              multiline
              rows={5}
              name="wild_zone_idea"
              label="Wild Ideas Zone"
              value={values?.wild_zone_idea}
              onChange={(e) => {
                handleChange(e);
              }}
            />
            <CommonTexField
              placeholder="Help us spot the oases in the desert of improvement. Share your thoughts on how we can turn those mirages into real, refreshing changes. Thirsty for change? So are we!"
              multiline
              rows={5}
              name="improvements_osis"
              label="The Improvement Oasis"
              value={values?.improvements_osis}
              onChange={(e) => {
                handleChange(e);
              }}
            />
            <CommonTexField
              placeholder=" Caught a colleague being awesome? Shower them with virtual confetti here! It's time to celebrate the unsung heroes and high-fivers among us."
              multiline
              rows={5}
              name="shoutout"
              label="Shoutouts and Kudos"
              value={values?.shoutout}
              onChange={(e) => {
                handleChange(e);
              }}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={sendAnonymous}
                  onChange={(event) => setSendAnonymous(event.target.checked)}
                />
              }
              label="I would like my response to be anonymous"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCloseAction()} variant="outlined">
              Cancel
            </Button>
            <CommonButton
              loading={feedBackData.loading}
              type="submit"
              variant="contained"
            >
              Submit
            </CommonButton>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default FeedBack;
